/**
 * Year progress bar — shows how many days have passed in the selected year.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { getYearProgress } from '@turnifly/shared/utils'

interface YearProgressBarProps {
  year: number
}

export const YearProgressBar: React.FC<YearProgressBarProps> = ({ year }) => {
  const { t } = useTranslation()
  const { daysPassed, percent } = getYearProgress(year)

  return (
    <div className="rounded-2xl bg-white/[0.03] border border-white/[0.06] p-3.5 mb-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-text-hint">
          {t('goals.yearProgress', { days: daysPassed, percent })}
        </span>
        <span className="text-xs font-bold text-text tabular-nums">
          {percent}%
        </span>
      </div>
      <div className="h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
        <motion.div
          className="h-full rounded-full bg-gradient-to-r from-primary to-accent"
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        />
      </div>
    </div>
  )
}
